import customizeScrollbar from "customsb";
import React, { useEffect, useState } from "react";
import Navbar from "../navbar/navbar";
import FooterBar from "../footer/footerBar";
import { vhostV1 } from "../funcoes";
import api from "../../services/api";
import SRI_pagination from "../components/pagination/pagination";
import BuscaVazaia from "../components/buscavazia/buscaVazia";
import { Toolbar } from "@mui/material";

function ProdEstoques() {

  const [busca, setBusca] = useState('');
  const [nPag, setnPag] = useState(1);
  const [totalPaginas, setTotalPaginas] = useState();
  const [produtos, setProdutos] = useState([]);
  const [sResult, setSresult] = useState(0);
  const [texto, setTexto] = useState('')


  let config = {
    headers: {
      'Authorization': localStorage.getItem("token")
    }
  }

  function handlePageChange(value) {
    if (value === "&laquo;" || value === '... ') {
      setnPag(1);
    } else if (value === "&lsaquo;") {
      if (nPag !== 1) {
        setnPag(-1);
      }
    } else if (value === "&rsaquo;") {
      setnPag(+1);
    } else if (value === "&raquo;" || value === ' ...') {
      setnPag(totalPaginas);
    } else {
      setnPag(value);
    }

  }

  const produto = {
    produtos: [
      {
        codigo: '405',
        descricao: 'ABACAXI',
        estoques: [ { loja: 'Loja teste', quantidade: 10 } ]
      },
      {
        codigo: '500',
        descricao: 'AGUA DE COCO',
        estoques: [ { loja: 'Loja teste', quantidade: 15 } ]
      },
      {
        codigo: '301',
        descricao: 'AGUA MINERAL C/ GAS E SEM GAS',
        estoques: [ { loja: 'Loja teste', quantidade: 30 } ]
      },
      {
        codigo: '1901',
        descricao: 'PICOLE 2',
        estoques: [
          { loja: 'Loja teste', quantidade: 66 },
          { loja: 'Loja oficial', quantidade: 20 }
        ]
      },
      {
        codigo: '1902',
        descricao: 'PICOLE 2.5',
        estoques: [
          { loja: 'Loja teste', quantidade: 10 },
          { loja: 'Loja oficial', quantidade: 25 }
        ]
      },
      {
        codigo: '356',
        descricao: 'PITU GOLD',
        estoques: [ { loja: 'Loja teste', quantidade: 5 } ]
      },
      {
        codigo: '31',
        descricao: 'STROGONOFF DE FRANGO',
        estoques: [ { loja: 'Loja teste', quantidade: 17 } ]
      },
      {
        codigo: '152',
        descricao: 'OVO COZIDO',
        estoques: [ { loja: 'Loja oficial', quantidade: 60 } ]
      },
      {
        codigo: '400',
        descricao: 'PINA COLADA',
        estoques: [ { loja: 'Loja oficial', quantidade: 5 } ]
      },
      {
        codigo: '306',
        descricao: 'SUCOS DE FRUTA JARRA',
        estoques: [ { loja: 'Loja oficial', quantidade: 10 } ]
      },
      {
        codigo: '305',
        descricao: 'SUCOS DE FRUTA MISTO',
        estoques: [ { loja: 'Loja oficial', quantidade: 50 } ]
      },
      {
        codigo: '304',
        descricao: 'SUCOS DE FRUTAS',
        estoques: [ { loja: 'Loja oficial', quantidade: 20 } ]
      }
    ]
  }




  useEffect(function() {

    console.log('entrei');

    const sJson = {}
    sJson.loja = localStorage.getItem('loja');
    sJson.empresa = 0;
    sJson.pagina = nPag;
    sJson.regPag = 10;
    sJson.busca = busca;

    console.log(sJson);


    api.post(vhostV1('webcash/estoque'), sJson,config)
      .then(function (response) {
        console.log('entrei no then');
        
        console.log(response);
        setProdutos(response.data);
        setSresult(response.data.result)
        setTotalPaginas(response.data.quantidadePagina);




      })
      .catch(function (error) {

        console.log(error);


      });
  }, [busca, nPag])

    

  // Obter todas as lojas únicas
  const lojas = [...new Set(produto.produtos.flatMap(p => p.estoques.map(e => e.loja)))];
  

  useEffect(() => {
    // O uso do useEffect garante que a função seja chamada apenas no lado do cliente
    customizeScrollbar({
      scrollbarWidth: "10px",
      trackBackground: "#333",
      thumbBackground:
        "linear-gradient(178.8deg, #ffa066 47.41%, #ff9666 65.18%, #ff783a 90.84%)",
      thumbBorderRadius: "10px",
    });
  }, []);
  return (
    <div>
      <Navbar />
     
      <div className="container-fluid titulo offset-lg-2 col-lg-8" id="produtos-page">
        <div className="col-7 ">
          <div className="input-group mb-3">
            <input onChange={(e) => setTexto(e.target.value)} type="text" className="form-control" placeholder="Pesquisar por nome" aria-describedby="button-addon2" />
            <button onClick={(e) => setBusca(texto)} className="btn btn-primary" type="button" id="button-addon2">Pesquisar</button>
          </div>
        </div>

        <table className="table table-hover table-striped">
      <thead>
        <tr>
          <th>Código</th>
          <th>Descrição</th>
          {lojas.map((loja) => (
            <th key={loja}>{loja}</th>
          ))}
        </tr>
      </thead>
      <tbody>
          
           { sResult === 1 ? produtos.produtos.map((prod) => (
          <tr key={prod.codigo}>
            <td>{prod.codigo}</td>
            <td>{prod.descricao}</td>
            {lojas.map((loja) => {
              const estoqueLoja = prod.estoques.find(e => e.loja === loja);
              return <td key={loja}>{estoqueLoja ? estoqueLoja.quantidade : 0}</td>;
            })}
          </tr>
        )) : BuscaVazaia}
      </tbody>
    </table>
      </div>

      <div className="row mt-5 mb-5 mr-5">
        <SRI_pagination totalPage={totalPaginas}
          page={nPag}
          limit={10}
          siblings={1}
          onPageChange={handlePageChange} />
      </div>

      <FooterBar />
    </div>
  );

}

export default ProdEstoques;